module.exports = __webpack_public_path__ + "img/pin-mobile.d2b1a52e.svg";